const IKEA_IMAGE_ORIGIN = 'https://www.ikea.com';
const IKEA_IMAGE_PATH = /^\/[a-z]{2}\/[a-z]{2}\/images\//i;
export const IKEA_IMAGE_PROXY_PREFIX = '/ikea-img';

/** The `/ikea-img` rewrite only exists on Vercel (see vercel.json), not on the CRA dev server. */
const PROXY_ENABLED = process.env.NODE_ENV === 'production';

/**
 * Serves IKEA product images through our own domain so they are cached on Vercel's CDN
 * and load even when a visitor's browser or network blocks ikea.com.
 */
export function ikeaImageSrc(raw) {
    if (typeof raw !== 'string' || !raw) return raw;
    if (!PROXY_ENABLED) return raw;
    let url;
    try {
        url = new URL(raw);
    } catch {
        return raw;
    }
    if (url.origin !== IKEA_IMAGE_ORIGIN || !IKEA_IMAGE_PATH.test(url.pathname)) return raw;
    return `${window.location.origin}${IKEA_IMAGE_PROXY_PREFIX}${url.pathname}${url.search}`;
}

/** Retries a failed proxied image straight from ikea.com once. */
export function installIkeaImageFallback() {
    const proxyBase = `${window.location.origin}${IKEA_IMAGE_PROXY_PREFIX}/`;
    document.addEventListener(
        'error',
        (event) => {
            const img = event.target;
            if (!(img instanceof HTMLImageElement)) return;
            const src = img.currentSrc || img.src;
            if (!src.startsWith(proxyBase)) return;
            img.src = `${IKEA_IMAGE_ORIGIN}/${src.slice(proxyBase.length)}`;
        },
        true,
    );
}
